"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutboundChargeType = exports.OutboundEntity = void 0;
var OutboundEntity;
(function (OutboundEntity) {
    OutboundEntity["PALLET"] = "PALLET";
    OutboundEntity["CARTON"] = "CARTON";
    OutboundEntity["SHIPMENT"] = "SHIPMENT";
    OutboundEntity["ORDER"] = "ORDER";
    OutboundEntity["LABEL"] = "LABEL";
    OutboundEntity["UNIT"] = "UNIT";
    OutboundEntity["KIT"] = "KIT";
})(OutboundEntity || (exports.OutboundEntity = OutboundEntity = {}));
var OutboundChargeType;
(function (OutboundChargeType) {
    // Parcel specific charges
    OutboundChargeType["PARCEL_OUTBOUND_HANDLING"] = "PARCEL_OUTBOUND_HANDLING";
    OutboundChargeType["PARCEL_SHIPMENT_LABELING"] = "PARCEL_SHIPMENT_LABELING";
    OutboundChargeType["PARCEL_SHIPMENT_PROCESSING"] = "PARCEL_SHIPMENT_PROCESSING";
    OutboundChargeType["PARCEL_CARTON_LABELLING"] = "PARCEL_CARTON_LABELLING";
    // Pallet specific charges
    OutboundChargeType["PALLET_OUTBOUND_HANDLING"] = "PALLET_OUTBOUND_HANDLING";
    OutboundChargeType["PALLET_CARTON_LABELLING"] = "PALLET_CARTON_LABELLING";
    OutboundChargeType["PALLET_LABELING"] = "PALLET_LABELING";
    OutboundChargeType["PALLET_SHIPMENT_PROCESSING"] = "PALLET_SHIPMENT_PROCESSING";
    OutboundChargeType["PALLET_SHIPMENT_BOL"] = "PALLET_SHIPMENT_BOL";
    OutboundChargeType["PALLET_STRETCH_WRAP"] = "PALLET_STRETCH_WRAP";
    OutboundChargeType["PALLET_SUPPLIED_PALLET"] = "PALLET_SUPPLIED_PALLET";
    OutboundChargeType["SHIPPING_FEE"] = "SHIPPING_FEE";
    OutboundChargeType["LABELING_FEE"] = "LABELING_FEE";
    OutboundChargeType["UNIT_PREP_FEE"] = "UNIT_PREP_FEE";
    OutboundChargeType["EACH_PICK_FEE"] = "EACH_PICK_FEE";
    OutboundChargeType["PREP_FEE"] = "PREP_FEE";
    // Amazon specific charges
    OutboundChargeType["PACKING_OPTION_FEE"] = "PACKING_OPTION_FEE";
    OutboundChargeType["PLACEMENT_OPTION_FEE"] = "PLACEMENT_OPTION_FEE";
})(OutboundChargeType || (exports.OutboundChargeType = OutboundChargeType = {}));
//# sourceMappingURL=OrderEstimateResponse.js.map